module.exports = __webpack_public_path__ + "media/images/landing/dno/product-6-071b1bd880d8f4658366fa40aa7d9817.png";